import script from "./FreezeInsuranceExpired.vue?vue&type=script&setup=true&lang=js"
export * from "./FreezeInsuranceExpired.vue?vue&type=script&setup=true&lang=js"

import "./FreezeInsuranceExpired.vue?vue&type=style&index=0&id=1ab4b6c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab4b6c2"]])

export default __exports__